import styled from 'styled-components/macro'

const SimplePage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  @media only screen and (max-width: 767px) {
    height: calc(100% - 100px);
  }
`

export default SimplePage
